import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { HasOne } from "@contember/binding";
import { Fragment as Fragment$1 } from "react";
const staticRenderFileKind = (fileKind, environment) => {
  const children = /* @__PURE__ */ jsxs(Fragment, { children: [
    !fileKind.baseEntity || !fileKind.childrenOutsideBaseEntity ? fileKind.children : null,
    fileKind.renderUploadedFile,
    fileKind.extractors.map((extractor, i) => /* @__PURE__ */ jsx(Fragment$1, { children: extractor.staticRender({ environment }) }, i))
  ] });
  return [
    fileKind.baseEntity === void 0 ? children : /* @__PURE__ */ jsx(HasOne, { field: fileKind.baseEntity, children }),
    fileKind.childrenOutsideBaseEntity ? fileKind.children : null
  ];
};
export {
  staticRenderFileKind
};
//# sourceMappingURL=staticRenderFileKind.js.map
